import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tab, TabPane } from 'semantic-ui-react'
import { StyledSegment } from '~/pages/Dairy/MilkFixedPrice/ShowMilkFixedPrice/style'
import BankData from './BankData'
import TaxData from './TaxData'

const FinancialInfo: React.FC = () => {
  const { t } = useTranslation()

  const [activeIndex, setActiveIndex] = useState(0)

  function renderPanes() {
    const panes = [
      {
        menuItem: t('Bank data'),
        component: <BankData />
      },
      {
        menuItem: t('Tax Data'),
        component: <TaxData />
      }
    ]

    return <Tab
      menu={{ secondary: true, pointing: true }}
      activeIndex={activeIndex}
      renderActiveOnly={false}
      onTabChange={(e, data) => setActiveIndex(data.activeIndex as number)}
      panes={panes.map((pane, index) => {
        return {
          menuItem: pane.menuItem,
          pane: <TabPane
            active={index === activeIndex}
            style={{ border: 'none', marginBottom: 0, borderRadius: 15, background: 'transparent' }}
            key={pane.menuItem}
          >
            {pane.component}
          </TabPane>
        }
      })}
    />
  }

  return <StyledSegment placeholder>
    {renderPanes()}
  </StyledSegment>
}
export default FinancialInfo
